import alt from "../alt";

class PersonActions {
  constructor() {
    this.generateActions(
      "updateWithApiData",
      "updateId",
      "updateToken",
      "updateDetails",
      "loginSucceeded",
      "loginFailed",
      "logout",
      "forgotPassword",
      "forgotSucceeded",
      "forgotFailed",
      "resetSucceeded",
      "resetFailed",
      "edit",
      "editSucceeded",
      "editFailed",
      "updatePaymentInfo",
      "paymentInfoUpdateSucceeded",
      "paymentInfoUpdateFailed",
      "resetPaymentInfoUpdate",
      "clearErrors",
      "loginWithFacebook",
      "refreshWithToken",
      "fetchSelf",
      "setGuestCheckout",

      // Used by other stores
      "addOneTimeLoginSucceededHook"
    );
  }

  login(email, password, noRedirect) {
    if (typeof email === "object") {
      return email;
    }
    return { email, password, noRedirect };
  }

  register(options) {
    return options;
  }

  registerWithFacebook(token, { onAccountExists, ...rest }) {
    if (typeof token === "object") {
      return { ...token, onAccountExists, ...rest };
    }
    return { token, onAccountExists, ...rest };
  }

  loginWithEventival(token, { onAccountExists, ...rest } = {}) {
    if (typeof token === "object") {
      return { ...token, onAccountExists, ...rest };
    }
    return { token, onAccountExists, ...rest };
  }

  loginWithIda(token, { onAccountExists, ...rest } = {}) {
    if (typeof token === "object") {
      return { ...token, onAccountExists, ...rest };
    }
    return { token, onAccountExists, ...rest };
  }

  loginWithSundance(token, { callback, onAccountExists, ...rest } = {}) {
    if (typeof token === "object") {
      return { callback, onAccountExists, ...token, ...rest };
    }
    return { token, callback, onAccountExists, ...rest };
  }

  loginWithAARP(token, { callback, onAccountExists, ...rest } = {}) {
    if (typeof token === "object") {
      return { callback, onAccountExists, ...token, ...rest };
    }
    return { token, callback, onAccountExists, ...rest };
  }

  loginWithCannes(username, password) {
    return { username, password };
  }

  resetPassword(token, password) {
    return { token, password };
  }
}

export default alt.createActions(PersonActions);



// WEBPACK FOOTER //
// ./src/app/actions/PersonActions.js